<div class="table-container">
    <div style="background: #e9e9f0;">
        <div class="d-flex justify-content-start m-2">
            <div class="d-flex mr-2">
                <button type="button" title="Select All" class="button-primary"
                    [disabled]="tableParams.pageInfo.pageCount === 0" (click)="refreshData()">Reload</button>
            </div>
            <div class="d-flex mr-2">
                <button type="button" title="Select All" class="button-primary"
                    [disabled]="tableParams.pageInfo.pageCount === 0" (click)="onSelectAllChange($event)">{{selectAll?
                    "De-Select All":"Select All"}}</button>
            </div>
            <div class="d-flex mr-2">
                <button type="button" title="Export" class="button-primary" (click)="onExportClicked($event)"
                    [disabled]="tableParams.pageInfo.pageCount === 0 || disableExport">
                    <mat-icon class="mat-icon-button icon-sm" svgIcon="mat:cloud_download"></mat-icon>
                </button>
            </div>
            <div class="d-flex mr-2">
                <button type="button" title="Advance Search"
                    [ngClass]="advanceSearch ? 'button-primary' : 'button-primary inactive'"
                    (click)="onAdvanceSearchChange($event)">
                    <mat-icon class="mat-icon-button icon-sm" svgIcon="mat:filter_alt"></mat-icon>
                </button>
                <button type="button" title="Multi-Select"
                    [ngClass]="multiSelect ? 'button-primary' : 'button-primary inactive'"
                    (click)="onMultiSelectChange($event)" [disabled]="rows.length === 0">
                    <mat-icon class="mat-icon-button icon-sm" svgIcon="mat:library_add"></mat-icon></button>

                <button type="button" title="Copy" [ngClass]="allowCopy ? 'button-primary' : 'button-primary inactive'"
                    (click)="onCopyChange($event)"
                    [disabled]="tableParams.pageInfo.pageCount === 0 || !allowCopy || selectedRowsIndex.length >1">
                    <mat-icon class="mat-icon-button icon-sm" svgIcon="mat:file_copy"></mat-icon></button>

            </div>

            <div class="d-flex mr-1" #origin>
                <button type="button" title="Add" class="button-green" [disabled]="disableAdd"
                    (click)="onAddClicked($event)">
                    <mat-icon class="mat-icon-button icon-sm" svgIcon="mat:add"></mat-icon>
                </button>
                <button type="button" title="Edit" class="button-primary" (click)="onEditClicked($event)"
                    [disabled]="disableEdit">
                    <mat-icon class="mat-icon-button icon-sm" svgIcon="mat:edit"></mat-icon>
                </button>
                <button type="button" title="Veiw Details" class="button-primary" (click)="
                    onViewClicked($event)" [disabled]="disableView">
                    <mat-icon class="mat-icon-button icon-sm" svgIcon="mat:view_headline"></mat-icon>
                </button>
                <button type="button" title="Delete" class="button-danger" (click)="
                    onDeleteClicked($event, origin)" [disabled]="disableDelete">
                    <mat-icon class="mat-icon-button icon-sm" svgIcon="mat:delete"></mat-icon>
                </button>
            </div>

        </div>
    </div>

    <div class="table-container">
        <table id="grid" class="table table-bordered table-sm">
            <thead>
                <tr>
                    <th class="text-center" style="width: 80px !important;">SN</th>
                    <th *ngFor="let c of columns; let i = index" [id]="c.fieldName" class="heading th-container pl-2"
                        [style.width.px]="defaultWidth">

                        <div class="d-flex justify-content-between align-items-center th-container" [id]="c.fieldName"
                            (click)="c.orderable ? headerClickHandler($event): ''" [class.clickable]="c.orderable">
                            {{c.displayName}}
                            <mat-icon class="mat-icon-button icon-sm" svgIcon="mat:keyboard_arrow_up"
                                *ngIf="c.fieldName==sortedFieldByAsc"></mat-icon>
                            <mat-icon class="mat-icon-button icon-sm" svgIcon="mat:keyboard_arrow_down"
                                *ngIf="c.fieldName==sortedFieldByDec"></mat-icon>

                        </div>
                        <span class="resizer" (mousedown)="onResizeMouseDown($event, i)"></span>
                    </th>
                </tr>
                <tr *ngIf="searchable">
                    <th>
                        <!-- <label class='switch' [title]="multiSelect ? 'Multi-select on' : 'Multi-select off'">
                            <input  type="checkbox" [checked]="multiSelect" (change)="onMultiSelectChange($event)">
                            <span class="slider round"></span>
                        </label> -->
                        <div class="d-flex justify-content-center align-items-center">
                            <div class="form-check"><input class='form-check-input position-static' *ngIf="multiSelect"
                                    id="selectAll" type="checkbox" (click)="onSelectAllChange($event)" /></div>
                        </div>

                    </th>
                    <th *ngFor="let c of columns" class="pl-2">
                        <div *ngIf="c.searchable" class="d-flex align-items-bottom">
                            <div *ngIf="advanceSearch">
                                <select [name]="c.fieldName" [className]="c.fieldName" [id]="'oprand_'+c.fieldName"
                                    (change)="operationChangeHandler($event)" class="searh-input">
                                    <option *ngFor="let op of operationTypes" [value]="op">{{op}}</option>
                                </select>
                            </div>
                            <div style="width: 100%;">
                                <div class="d-flex align-items-center">
                                    <input [type]="c.fieldDataType" [name]="c.fieldName" [id]="'search_'+c.fieldName"
                                        (keyup)="searchKeyUpHandler($event)" class="searh-input mr-1"
                                        placeholder="Search..." />
                                    <button type="button" (click)="searchBtnCliked()" *ngIf="isMobile">
                                        <mat-icon class="mat-icon-button icon-sm bg-light"
                                            svgIcon="mat:search"></mat-icon>
                                    </button>

                                </div>
                            </div>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody *ngIf="tableParams.tableMode === 'SP'" class="table content" (scroll)="onScroll($event)">
                <tr *ngFor="let row of rows; let i = index" [style.background-color]="(i%2==1) ? '#f5f5f8' : '#ffffff '"
                    [class.selected-row]="isRowSelected(i)" [id]="(i)" (click)="rowClickHandler($event,i)">
                    <td>
                        <div class='d-flex justify-content-center align-items-center'>
                            <input [id]="i+1" class='mr-1' [type]="multiSelect ? 'checkbox' : 'radio'" name="selected"
                                (change)="onRowSelectionChange(i, $event)" [checked]="isSelected(i,row.id)"
                                [attr.rowid]="row.id" />
                            <label [for]="i+1" class='form-check-label'>{{getRowNumber(i)}}</label>
                        </div>
                    </td>
                    <td *ngFor="let c of columns;" class="pl-2">
                        <div class="td-container" (mouseover)="cellMouseOver($event)">
                            {{renderCell(c, row)}}
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <div class="footer d-flex align-items-center justify-content-center">
        <div class="d-flex justify-content-center">
            <div class="d-flex align-items-center mr-4">
                <label class="mr-2">Page Size:</label>
                <select [value]="tableParams.pageInfo.pageSize" (change)="onPageSizeChanged($event)">
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="200">200</option>
                    <option value="300">300</option>
                    <option value="500">500</option>
                </select>
            </div>

            <div class="d-flex">

                <button type="button" title="First Page" (click)="firstPageClicked($event)"
                    class="btn btn-sm btn-secondary py-0"
                    [disabled]="tableParams.pageInfo.pageCount === 0 ||tableParams.pageInfo.page == 1">
                    << First </button>
                        <input type="button" value="< Prev" class="btn btn-sm btn-secondary ml-3 mr-3 py-0"
                            (click)="onPreviousClicked()" [disabled]="tableParams.pageInfo.page == 1" />

                        <div class="d-flex align-items-center">
                            Page: <select class="mx-1" (change)="onPageChanged($event)"
                                [value]="tableParams.pageInfo.page">
                                <option *ngFor="let p of pageList" [value]="p">{{p}}</option>
                            </select>
                        </div>
                        <input type="button" value="Next >" class="btn btn-sm btn-secondary ml-3 py-0"
                            (click)="onNextClicked()"
                            [disabled]="tableParams.pageInfo.page == tableParams.pageInfo.pageCount" />

                        <button type="button" title="Last Page" (click)="lastPageClicked($event)"
                            class="btn btn-sm btn-secondary ml-3 py-0"
                            [disabled]="tableParams.pageInfo.pageCount === 0 ||tableParams.pageInfo.page == tableParams.pageInfo.pageCount">
                            Last >>
                        </button>
                        <div class="d-flex align-items-center ml-3">
                            Record Count:
                            <input type="text" [value]="tableParams.pageInfo.recordCount" class="mx-1 text-center bg-white p-1"
                                [style.width]="(tableParams.pageInfo.recordCount?.toString().length + 1) + 'ch'" disabled />
                        </div>
            </div>
        </div>
    </div>
</div>